export const themeColors = {
    ui_blue: "#11a9e2",
    selection: "#DAE9F0",
    rollover: "#E8F7FD",
    lightBlue: "#DAE9F0",
    hoverBlue: "#F7FAFC",
    // lightGray: "#f5f5f9",
    lightGray: "#eeeeee",
    darkGray: "#222",
    yellow: "#ffaa00",
    warning: "orangered",
    textSelection: "rgba(17,169,226,0.3)"
};

export const uiTheme = {};
